import React, { Component } from "react";
import _ from 'lodash';
import { Row, Col, Input, Select, Icon, Button, notification, Card, message } from "antd";
import Request from "../../../request";
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

const { Option } = Select;
class StaffSetup extends Component {
    state = {
        staffList: [{ name: '', email: '', userMobileCode: '', userMobile: '', password: '', userGroup: '' }],
        groups: [],
        loading: false,
        cardLoading: false
    };


    handleStaffChange = (index, field, value) => {
        // if (field === 'userMobile' && value.length !== 10) {
        //     notification.error({
        //         message: 'User Mobile Must be of 10 Digits'
        //     });
        //     return;
        // }
        let list = _.cloneDeep(this.state.staffList);
        list[index][field] = value;
        this.setState({ staffList: list });
    }


    addStaffRow = () => {
        const defaultCode = this.props.phoneCodes.length > 0 ? this.props.phoneCodes[0].key : '';
        this.setState({
            staffList: [...this.state.staffList, { name: '', email: '', userMobileCode: '', userMobile: '', password: '', userGroup: '' }]
        });
    }

    loadUsers = async (params = {}) => {
        params.userType = { $ne: "Student" };
        params.active = true;
        params.options = "all";
        params.isBusinessAdmin = false;
        let response = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] });
        let staffList = response.data.reduce((temp, vv) => {
            temp.push({
                userGroup: vv && vv.userGroup && vv.userGroup._id ? vv.userGroup._id : vv.userGroup,
                userMobileCode: vv && vv.userMobileCode ? vv.userMobileCode : null,
                name: vv && vv.name ? vv.name : '',
                email: vv && vv.email ? vv.email : '',
                userMobile: vv && vv.userMobile ? vv.userMobile : '',
                _id: vv && vv._id ? vv._id : null,
            });
            return temp;
        }, []);
        this.setState({ staffList });
    }


    loadInitialData = async () => {
        this.setState({ cardLoading: true });
        let userGroups = await Request.loadGroups();
        this.loadUsers();
        this.setState({ cardLoading: false });
        if (userGroups && userGroups.data) {
            this.setState({ groups: userGroups.data });
        }
    }


    componentDidMount() {
        this.loadInitialData()

    }

    removeStaffRow = (index) => {
        let list = _.cloneDeep(this.state.staffList);
        list.splice(index, 1);
        this.setState({ staffList: list });
    }

    // handleStaffSubmit = () => {
    //     const staffList = this.state.staffList;
    //     let hasData = true;

    //     for (let i = 0; i < staffList.length; i++) {
    //         const staff = staffList[i];

    //         // For NEW users → password required
    //         if (!staff._id) {
    //             if (!staff.name || !staff.email || !staff.userGroup || !staff.userMobile || !staff.password) {
    //                 hasData = false;
    //                 break;
    //             }
    //         } else {
    //             // For EXISTING users → password not required
    //             if (!staff.name || !staff.email || !staff.userGroup || !staff.userMobile) {
    //                 hasData = false;
    //                 break;
    //             }
    //         }
    //     }

    //     if (!hasData) {
    //         notification.error({
    //             message: 'Please fill all required fields'
    //         });
    //         return;
    //     }

    //     const payload = {
    //         users: staffList,
    //         businessId: activeUser.businessId
    //     };
    //     this.setState({ loading: true });
    //     Request.addMultiUsers(payload).then((res) => {
    //         this.setState({ loading: false });
    //         if (res && !res.error) {
    //             notification.success({ message: 'Staff Accounts Created Successfully' });
    //             this.props.onNext()
    //         } else {
    //             notification.error({
    //                 message: 'Error creating staff',
    //                 description: res && res.msg ? res.msg : 'Something went wrong'
    //             });
    //         }
    //     });
    // };

    handleStaffSubmit = () => {
        const staffList = this.state.staffList;

        // ✅ Check if ALL rows are completely empty
        const isAllEmpty = staffList.every(staff =>
            !staff.name &&
            !staff.email &&
            !staff.userGroup &&
            !staff.userMobile &&
            !staff.password
        );

        // 👉 If nothing entered → skip API
        if (isAllEmpty) {
            this.props.onNext();
            return;
        }

        // ✅ Validate only filled rows
        for (let i = 0; i < staffList.length; i++) {
            const staff = staffList[i];

            const hasAnyValue =
                staff.name ||
                staff.email ||
                staff.userGroup ||
                staff.userMobile ||
                staff.password;

            // Skip completely empty rows
            if (!hasAnyValue) continue;

            // 🔥 New user → password required
            if (!staff._id) {
                if (!staff.name || !staff.email || !staff.userGroup || !staff.userMobile || !staff.password) {
                    notification.error({
                        message: `Please complete all fields for row ${i + 1}`
                    });
                    return;
                }
            } else {
                // 🔥 Existing user → password optional
                if (!staff.name || !staff.email || !staff.userGroup || !staff.userMobile) {
                    notification.error({
                        message: `Please complete all required fields for row ${i + 1}`
                    });
                    return;
                }
            }
        }

        // ✅ Call API
        const payload = {
            users: staffList,
            businessId: activeUser.businessId
        };

        this.setState({ loading: true });

        Request.addMultiUsers(payload).then((res) => {
            this.setState({ loading: false });

            if (res && !res.error) {
                notification.success({ message: 'Staff Accounts Saved Successfully' });
                this.props.onNext();
            } else {
                notification.error({
                    message: 'Error saving staff',
                    description: res && res.msg ? res.msg : 'Something went wrong'
                });
            }
        });
    };
    onPrev = () => {
        this.props.onPrev();
    }


    render() {
        let { phoneCodes } = this.props;
        let { staffList, groups, loading, cardLoading } = this.state;
        return (
            <Card loading={cardLoading}>
                <h3 style={{ color: '#1890ff', marginBottom: 20 }}><Icon type="user-add" /> Create Team Accounts</h3>
                {staffList.map((staff, index) => {
                    return (
                        <div key={index} className="staff-card">
                            <Row gutter={[12, 12]} align="middle">
                                <Col span={4}>
                                    <label>NAME</label>
                                    <Input placeholder="Name" value={staff.name} onChange={(e) => { this.handleStaffChange(index, 'name', e.target.value) }} />
                                </Col>
                                <Col span={4}>
                                    <label>EMAIL</label>
                                    <Input placeholder="Email" value={staff.email} onChange={(e) => { this.handleStaffChange(index, 'email', e.target.value) }} />
                                </Col>
                                <Col span={3}>
                                    <label>ROLE</label>
                                    <Select style={{ width: '100%' }} value={staff.userGroup} onChange={(v) => { this.handleStaffChange(index, 'userGroup', v) }}>
                                        {groups && groups.map((group) => {
                                            return <Option key={group._id} value={group._id}>{group.groupName}</Option>
                                        })}
                                    </Select>
                                </Col>
                                <Col span={3}>
                                    <label>CODE</label>
                                    <Select showSearch optionFilterProp="children" style={{ width: '100%' }} value={staff.userMobileCode} onChange={(v) => { this.handleStaffChange(index, 'userMobileCode', v) }}>
                                        {phoneCodes.map((pc) => {
                                            return <Option key={pc._id} value={pc._id}>{pc.display}</Option>
                                        })}
                                    </Select>
                                </Col>
                                <Col span={4}>
                                    <label>MOBILE</label>
                                    <Input placeholder="Mobile" value={staff.userMobile} onChange={(e) => { this.handleStaffChange(index, 'userMobile', e.target.value) }} />
                                </Col>
                                <Col span={4}>
                                    <label>PASSWORD</label>
                                    <Input.Password placeholder="Password" value={staff.password} onChange={(e) => { this.handleStaffChange(index, 'password', e.target.value) }} />
                                </Col>
                                <Col span={2} style={{ textAlign: 'center', paddingTop: '15px' }}>
                                    {staffList.length > 1 && <Icon type="delete" style={{ color: '#ff4d4f', cursor: 'pointer' }} onClick={() => { this.removeStaffRow(index) }} />}
                                </Col>
                            </Row>
                        </div>
                    )
                })}
                <Button type="dashed" onClick={this.addStaffRow} block style={{ height: 40, marginTop: 10 }}>
                    <Icon type="plus" /> Add Member
                </Button>
                <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                    <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>
                    <Button type="primary" loading={loading} onClick={this.handleStaffSubmit} style={{ height: 40, width: 140 }}>
                        FINALIZE STAFF <Icon type="arrow-right" />
                    </Button>
                </div>
            </Card>
        )
    }
}



export default StaffSetup;